import React from 'react';
import { Grid } from '@material-ui/core';

import { NewsletterForm } from 'views/Newsletter/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <NewsletterForm />
        </Grid>
      </Grid>
    </div>
  );
};
